import { ALL_LANGUAGES, isRtlLanguage } from '@repo/sdk';
import type { SupportedLocaleType } from './supported-locales';

export interface ILocaleMetadata {
  nativeName: string;
  englishName: string;
  flag: string;
  countryCode: string;
  dir: 'ltr' | 'rtl';
  fontStack: string;
}

const SYSTEM_FONT_STACK = 'system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';

const LOCALE_FONT_STACK: Record<string, string> = {
  zh: '"PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans SC", sans-serif',
  hi: '"Noto Sans Devanagari", "Mangal", "Lohit Devanagari", sans-serif',
  bn: '"Noto Sans Bengali", "Vrinda", "Lohit Bengali", sans-serif',
  ar: '"Readex Pro", "SF Arabic", "Geeza Pro", "Noto Sans Arabic", sans-serif',
  fa: '"Vazirmatn", "SF Arabic", "Geeza Pro", "Noto Sans Arabic", sans-serif',
  ur: '"Noto Nastaliq Urdu", "Jameel Noori Nastaleeq", "Tahoma", sans-serif',
  ru: '"Inter", "Helvetica Neue", Arial, sans-serif',
};

function buildLocaleMetadata(locale: string): ILocaleMetadata {
  const info = ALL_LANGUAGES[locale];
  if (!info) {
    throw new Error(`Missing language metadata for locale: ${locale}`);
  }
  return {
    nativeName: info.nativeName,
    englishName: info.name,
    flag: info.flag,
    countryCode: info.countryCode,
    dir: isRtlLanguage(locale) ? 'rtl' : 'ltr',
    fontStack: LOCALE_FONT_STACK[locale]
      ? `${LOCALE_FONT_STACK[locale]}, ${SYSTEM_FONT_STACK}`
      : SYSTEM_FONT_STACK,
  };
}

const ENGLISH_METADATA: ILocaleMetadata = {
  nativeName: 'English',
  englishName: 'English',
  flag: '🇺🇸',
  countryCode: 'US',
  dir: 'ltr',
  fontStack: SYSTEM_FONT_STACK,
};

export function getLocaleMetadata(locale: SupportedLocaleType): ILocaleMetadata {
  if (locale === 'en') {
    return ENGLISH_METADATA;
  }
  return buildLocaleMetadata(locale);
}
